<script setup lang="ts">
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import { computed } from "vue";

const route = useRoute();
const { t, te } = useI18n();

const title = computed(() => {
  const key = route.meta.titleKey as string | undefined;
  return key && te(key) ? t(key) : (route.name?.toString() ?? "");
});
</script>

<template>
  <section class="placeholder">
    <h1>{{ title }}</h1>
    <p>
      Route <code>{{ route.fullPath }}</code> placeholder — to be implemented in a later milestone.
    </p>
  </section>
</template>

<style scoped>
.placeholder {
  max-width: 56rem;
}
.placeholder p {
  color: var(--color-fg-dim);
}
</style>
